import React, { useState, useEffect } from 'react'
import styles from '../../Css/CustomSettings.module.css'
import VirtualStudio from './ApplyType/VirtualStudio';
import CustomWalls from './ApplyType/CustomWalls';



function CustomSettings(props) {


    return (
        <div>
            <div className={[styles['right-content-area'], 'row m-0 '].join(' ')}>

                <ul className={[styles['tab-btns'], 'col-md-12'].join(' ')}>
                    <li><button onClick={() => {props.setApplyType('VS');props.setCustomWall('')}} className={props.applyType === 'VS' ? [styles['active'], ''].join(' ') : [styles[''], ''].join(' ')}>Virtual Studio</button></li>
                    {props.prodCatId === 'cat_d8R14zUNE' && !props.isBulk ?
                        <li><button onClick={() => {props.setApplyType('CW');props.handleBackground('','','')}} className={props.applyType === 'CW' ? [styles['active'], ''].join(' ') : [styles[''], ''].join(' ')}>Custom Walls</button></li>
                        :
                        null
                    }
                </ul>
                {props.applyType === 'VS' ?
                    <VirtualStudio
                        isSolidBackgrounds={props.isSolidBackgrounds}
                        favBgList={props.favBgList}
                        backgroundId={props.backgroundId}
                        handleBackground={props.handleBackground}
                        handleCarsFavList={props.handleCarsFavList}
                        handleBackgroundList={props.handleBackgroundList}
                        bgList={props.bgList}
                        colorList={props.colorList}
                        handleCarsBgList={props.handleCarsBgList}
                        handleNumberPlate={props.handleNumberPlate}
                        numberPlate={props.numberPlate}
                        isDelearshipLogo={props.isDelearshipLogo}
                        isBackgroundBlur={props.isBackgroundBlur}
                        handleColorEnhancement={props.handleColorEnhancement}
                        checkColorEnhancement={props.checkColorEnhancement}
                        handleWindowCorrection={props.handleWindowCorrection}
                        checkWindowCorrection={props.checkWindowCorrection}
                        isLoggedIn={props.isLoggedIn}
                        angle={props.angle}
                        handleAngle={props.handleAngle}
                        handleColorBackground={props.handleColorBackground}
                        marketPlaceList={props.marketPlaceList}
                        setMarketId={props.setMarketId}
                        marketId={props.marketId}
                        frontendData={props.frontendData}
                        imageProcessing={props.imageProcessing}
                        checkShadow={props.checkShadow}
                        handleCheckShadow={props.handleCheckShadow}
                        handleMarketId={props.handleMarketId}
                        modelData={props.modelData}
                        set_modelId={props.set_modelId}
                        modelPose={props.modelPose}
                        modelId={props.modelId}
                        add_poses={props.add_poses}
                        poseToDisplay={props.poseToDisplay}
                        categoryType={props.categoryType}
                        checkBodyReflection={props.checkBodyReflection}
                        setCheckBodyReflection={props.setCheckBodyReflection}
                        setCheckBrightness={props.setCheckBrightness}
                        setCheckTint={props.setCheckTint}
                        setCheckBlur={props.setCheckBlur}
                        handleNumberPlateLogo={props.handleNumberPlateLogo}
                        prodCatId = {props.prodCatId}
                        handleImageModalInImageSection = {props.handleImageModalInImageSection}
                        shadowType = {props.shadowType}
                        handleShadowType = {props.handleShadowType}
                        setApplyShadow = {props.setApplyShadow}
                        applyShadow = {props.applyShadow}
                        seeThrough={props.seeThrough}
                        setSeeThrough={props.setSeeThrough}
                    />
                    :
                    <CustomWalls
                        isSolidBackgrounds={props.isSolidBackgrounds}
                        favBgList={props.favBgList}
                        backgroundId={props.backgroundId}
                        handleBackground={props.handleBackground}
                        handleCarsFavList={props.handleCarsFavList}
                        handleBackgroundList={props.handleBackgroundList}
                        bgList={props.bgList}
                        colorList={props.colorList}
                        handleCarsBgList={props.handleCarsBgList}
                        handleNumberPlate={props.handleNumberPlate}
                        numberPlate={props.numberPlate}
                        isDelearshipLogo={props.isDelearshipLogo}
                        isBackgroundBlur={props.isBackgroundBlur}
                        handleColorEnhancement={props.handleColorEnhancement}
                        checkColorEnhancement={props.checkColorEnhancement}
                        handleWindowCorrection={props.handleWindowCorrection}
                        checkWindowCorrection={props.checkWindowCorrection}
                        isLoggedIn={props.isLoggedIn}
                        angle={props.angle}
                        handleAngle={props.handleAngle}
                        handleColorBackground={props.handleColorBackground}
                        marketPlaceList={props.marketPlaceList}
                        setMarketId={props.setMarketId}
                        marketId={props.marketId}
                        frontendData={props.frontendData}
                        imageProcessing={props.imageProcessing}
                        checkShadow={props.checkShadow}
                        handleCheckShadow={props.handleCheckShadow}
                        handleMarketId={props.handleMarketId}
                        modelData={props.modelData}
                        set_modelId={props.set_modelId}
                        modelPose={props.modelPose}
                        modelId={props.modelId}
                        add_poses={props.add_poses}
                        poseToDisplay={props.poseToDisplay}
                        categoryType={props.categoryType}
                        customWall={props.customWall}
                        wallData={props.wallData}
                        setCustomWall={props.setCustomWall}
                        applyWay={props.applyWay}
                        setApplyWay={props.setApplyWay}
                        setWallData={props.setWallData}
                        greyScale={props.greyScale}
                        setGreyScale={props.setGreyScale}
                    />
                }

                <div className={[styles['solid-bg'],'col-md-12 col-lg-12 border-0 pb-0'].join(' ')}>
                    <div className={[styles['number-logo'],'row m-0 create-magic'].join(' ')}>
                        {/* { */}
                            {/* props.prodCatId === 'cat_d8R14zUNE' && (props.backgroundId === '' && props.customWall==='') ?
                            <button onClick={props.imageProcessing} disabled><img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/click.png"/> Create Magic</button>
                             : */}
                            <button onClick={props.imageProcessing} ><img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/click.png"/> Create Magic</button>
                        {/* } */}
                        {/* <button onClick={props.imageProcessing} disabled><img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/click.png"/> Create Magic</button> */}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CustomSettings
